export default "__VITE_ASSET__16e48b25__"